import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/app.service";


@Component({
  selector: 'app-computer-club',
  templateUrl: './computer-club.component.html',
  styleUrls: ['./computer-club.component.scss']
})
export class ComputerClubComponent implements OnInit {    
  selectedLanguage = "";
  computer_data: any[] = [];

  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.FetchData();
  }

  FetchData() {
    this.appService.getContents().subscribe((response: any) => {
      console.log(response, "Library API Response");

      if (response?.data) {
        // Filter for Library category
        this.computer_data = response.data.filter(
          (x: any) => x.ContentCategoryName === " Computer Lab"
        );
        console.log(this.computer_data, "Filtered computer Data");
      }
    });
  }
}
